import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import './LegalPages.css';

export default function Widerruf() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('de');
  const [formData, setFormData] = useState({
    serviceDescription: '',
    orderDate: '',
    name: '',
    address: '',
    email: '',
    date: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setLanguage(user.language || 'de');
        // Pre-fill email if user is logged in
        setFormData(prev => ({ ...prev, email: user.email || '', name: user.name || '' }));
      } catch (e) {
        setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
      }
    } else {
      setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
    }
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create email content
    const subject = language === 'de' ? 'Widerruf meines Vertrags' : 'Withdrawal of my Contract';
    const body = language === 'de' 
      ? `An: StoryTales
Alex Mickel
Am Neuberg 20
67593 Westhofen
Deutschland

Widerrufserklärung

Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über die Erbringung der folgenden Dienstleistung:

Beschreibung der Dienstleistung: ${formData.serviceDescription}

Bestellt am: ${formData.orderDate}

Name: ${formData.name}

Anschrift: ${formData.address}

E-Mail-Adresse: ${formData.email}

Datum: ${formData.date}

Mit freundlichen Grüßen
${formData.name}`
      : `To: StoryTales
Alex Mickel
Am Neuberg 20
67593 Westhofen
Germany

Withdrawal Statement

I hereby give notice that I withdraw from my contract for the provision of the following service:

Description of service: ${formData.serviceDescription}

Ordered on: ${formData.orderDate}

Name: ${formData.name}

Address: ${formData.address}

Email address: ${formData.email}

Date: ${formData.date}

Sincerely,
${formData.name}`;

    // Open email client with pre-filled content
    window.location.href = `mailto:info@storytales.xyz?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
        >
          ← {language === 'de' ? 'Zurück' : 'Back'}
        </Button>
        <Button 
          variant="outline" 
          onClick={toggleLanguage}
          className="language-toggle"
        >
          {language === 'de' ? '🇬🇧 English' : '🇩🇪 Deutsch'}
        </Button>
      </div>

      <div className="legal-content">
        {language === 'de' ? (
          <>
            <h1>Muster-Widerrufsformular</h1>
            <p className="last-updated">
              Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus 
              und senden Sie es zurück.
            </p>

            <form className="withdrawal-form" onSubmit={handleSubmit}>
              <section>
                <h2>An</h2>
                <p>
                  StoryTales<br />
                  Alex Mickel<br />
                  Am Neuberg 20<br />
                  67593 Westhofen<br />
                  Deutschland<br />
                  <br />
                  E-Mail: info@storytales.xyz
                </p>
              </section>

              <section>
                <h2>Widerrufserklärung</h2>
                <p>
                  Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über 
                  die Erbringung der folgenden Dienstleistung
                </p>
                <div className="form-field">
                  <Label htmlFor="serviceDescription">Beschreibung der Dienstleistung:</Label>
                  <Input
                    id="serviceDescription"
                    type="text"
                    placeholder="z.B. Pro-Abonnement monatlich"
                    value={formData.serviceDescription}
                    onChange={(e) => setFormData({...formData, serviceDescription: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="orderDate">Bestellt am / erhalten am:</Label>
                  <Input
                    id="orderDate"
                    type="date"
                    value={formData.orderDate}
                    onChange={(e) => setFormData({...formData, orderDate: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="name">Name des Verbrauchers:</Label>
                  <Input
                    id="name"
                    type="text"
                    placeholder="Ihr vollständiger Name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="address">Anschrift des Verbrauchers:</Label>
                  <Input
                    id="address"
                    type="text"
                    placeholder="Ihre vollständige Adresse"
                    value={formData.address}
                    onChange={(e) => setFormData({...formData, address: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="email">E-Mail-Adresse (zur Bestätigung):</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="ihre.email@beispiel.de"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="date">Datum:</Label>
                  <Input
                    id="date"
                    type="date"
                    value={formData.date}
                    onChange={(e) => setFormData({...formData, date: e.target.value})}
                    required
                  />
                </div>
              </section>

              <div className="form-actions">
                <Button type="submit" className="submit-withdrawal-btn">
                  📧 Widerruf per E-Mail senden
                </Button>
              </div>

              <p className="form-note">
                Nach dem Klicken öffnet sich Ihr E-Mail-Programm mit vorausgefülltem Widerruf. 
                Bitte überprüfen Sie die Angaben und senden Sie die E-Mail ab.
              </p>
            </form>

            <section>
              <h2>Hinweise zum Widerruf</h2>
              <ul>
                <li>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.</li>
                <li>Sie können dieses Formular per E-Mail an info@storytales.xyz oder per Post senden.</li>
                <li>Wir werden Ihnen den Erhalt des Widerrufs umgehend bestätigen.</li>
                <li>Die Rückzahlung erfolgt innerhalb von 14 Tagen nach Erhalt Ihres Widerrufs.</li>
                <li>Bei vollständiger Vertragserfüllung (nach Ihrer Zustimmung) erlischt das Widerrufsrecht.</li>
              </ul>
            </section>

            <section>
              <h2>Alternative: Widerruf per E-Mail</h2>
              <p>
                Sie können auch eine formlose E-Mail an <strong>info@storytales.xyz</strong> senden. 
                Bitte geben Sie dabei folgende Informationen an:
              </p>
              <ul>
                <li>Ihren vollständigen Namen</li>
                <li>Ihre bei der Registrierung verwendete E-Mail-Adresse</li>
                <li>Die Bezeichnung des Abonnements (z.B. "Pro-Abonnement monatlich")</li>
                <li>Das Datum des Vertragsabschlusses</li>
                <li>Eine eindeutige Widerrufserklärung</li>
              </ul>
            </section>
          </>
        ) : (
          <>
            <h1>Model Withdrawal Form</h1>
            <p className="last-updated">
              If you wish to withdraw from the contract, please fill out this form and send it back.
            </p>

            <form className="withdrawal-form" onSubmit={handleSubmit}>
              <section>
                <h2>To</h2>
                <p>
                  StoryTales<br />
                  Alex Mickel<br />
                  Am Neuberg 20<br />
                  67593 Westhofen<br />
                  Germany<br />
                  <br />
                  Email: info@storytales.xyz
                </p>
              </section>

              <section>
                <h2>Withdrawal Statement</h2>
                <p>
                  I hereby give notice that I withdraw from my contract for 
                  the provision of the following service
                </p>
                <div className="form-field">
                  <Label htmlFor="serviceDescription">Description of service:</Label>
                  <Input
                    id="serviceDescription"
                    type="text"
                    placeholder="e.g., Pro subscription monthly"
                    value={formData.serviceDescription}
                    onChange={(e) => setFormData({...formData, serviceDescription: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="orderDate">Ordered on / received on:</Label>
                  <Input
                    id="orderDate"
                    type="date"
                    value={formData.orderDate}
                    onChange={(e) => setFormData({...formData, orderDate: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="name">Name of consumer:</Label>
                  <Input
                    id="name"
                    type="text"
                    placeholder="Your full name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="address">Address of consumer:</Label>
                  <Input
                    id="address"
                    type="text"
                    placeholder="Your complete address"
                    value={formData.address}
                    onChange={(e) => setFormData({...formData, address: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="email">Email address (for confirmation):</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="your.email@example.com"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                  />
                </div>
              </section>

              <section>
                <div className="form-field">
                  <Label htmlFor="date">Date:</Label>
                  <Input
                    id="date"
                    type="date"
                    value={formData.date}
                    onChange={(e) => setFormData({...formData, date: e.target.value})}
                    required
                  />
                </div>
              </section>

              <div className="form-actions">
                <Button type="submit" className="submit-withdrawal-btn">
                  📧 Send Withdrawal via Email
                </Button>
              </div>

              <p className="form-note">
                After clicking, your email program will open with a pre-filled withdrawal. 
                Please review the information and send the email.
              </p>
            </form>

            <section>
              <h2>Withdrawal Instructions</h2>
              <ul>
                <li>The withdrawal period is fourteen days from the date of contract conclusion.</li>
                <li>You can send this form by email to info@storytales.xyz or by post.</li>
                <li>We will promptly confirm receipt of your withdrawal.</li>
                <li>Refund will be made within 14 days of receiving your withdrawal.</li>
                <li>The right of withdrawal expires upon complete contract performance (with your consent).</li>
              </ul>
            </section>

            <section>
              <h2>Alternative: Withdrawal by Email</h2>
              <p>
                You can also send an informal email to <strong>info@storytales.xyz</strong>. 
                Please include the following information:
              </p>
              <ul>
                <li>Your full name</li>
                <li>Your registration email address</li>
                <li>The subscription description (e.g., "Pro subscription monthly")</li>
                <li>The date of contract conclusion</li>
                <li>A clear withdrawal statement</li>
              </ul>
            </section>
          </>
        )}
      </div>
    </div>
  );
}
